import React, { FC } from "react";

import { startOfMonth, endOfMonth } from "date-fns";

import {
  useApisAnalyticsPlansMeetingNotesIndex,
  useDateRange,
  useMultiDivisionMultiSectionDropdown,
  usePrevNextSelectMonth,
  useProvidersCurrentEmployee,
} from "~/hooks";

import {
  EmployeeLayout,
  EmployeeLayoutMainContent,
} from "~/components/layouts";
import { AnalyticsMeetingNotesTemplate } from "~/components/templates";

const today = new Date();

export const AnalyticsPlansMeetingNotesIndex: FC = () => {
  const { currentEmployee } = useProvidersCurrentEmployee();

  const breadCrumbItems = [
    {
      label: "1on1・MTG分析",
      href: "/analytics_plans/meeting_notes",
    },
  ];

  const {
    selectableDivisions,
    selectedDivisions,
    onDivisionChange,
    optionSelectableSections,
    optionSelectedSections,
    onSectionChange,
    selectableEmployees,
    selectedEmployee,
    onEmployeeChange,
  } = useMultiDivisionMultiSectionDropdown({
    selectableDivisions: currentEmployee?.businessDivisions,
    selectableSections: currentEmployee?.businessSections,
    isSelectEmployee: true,
  });

  const [
    {
      startDate,
      formattedStartDate,
      endDate,
      dateArray,
      formattedEndDate,
      onChange: onChangeDateRange,
    },
  ] = useDateRange([startOfMonth(today), endOfMonth(today)]);

  const {
    targetDate,
    targetDateString,
    handlePrevMonthClick,
    handleNextMonthClick,
  } = usePrevNextSelectMonth();

  const { data, isLoading } = useApisAnalyticsPlansMeetingNotesIndex({
    params: {
      businessDivisionIds: selectedDivisions.map((division) => division.id),
      businessSectionIds: optionSelectedSections.map((section) => section.id),
      fromDate: formattedStartDate || undefined,
      toDate: formattedEndDate || undefined,
      targetDate: targetDateString,
      employeeIds: selectedEmployee ? [selectedEmployee.id] : undefined,
    },
    config: {
      enabled: !!(formattedStartDate && formattedEndDate),
    },
  });

  return (
    <>
      <EmployeeLayout
        withRightSidebar={false}
        breadCrumbItems={breadCrumbItems}
      >
        <EmployeeLayoutMainContent withRightSidebar={false}>
          <AnalyticsMeetingNotesTemplate
            formattedStartDate={formattedStartDate}
            formattedEndDate={formattedEndDate}
            selectedDivisions={selectedDivisions}
            optionSelectedSections={optionSelectedSections}
            data={data}
            isLoading={isLoading}
            onChangeDateRange={onChangeDateRange}
            onDivisionChange={onDivisionChange}
            onSectionChange={onSectionChange}
            selectableDivisions={selectableDivisions}
            optionSelectableSections={optionSelectableSections}
            startDate={startDate}
            endDate={endDate}
            selectedDropdownSections={optionSelectedSections}
            dateArray={dateArray}
            selectedEmployee={selectedEmployee}
            onEmployeeChange={onEmployeeChange}
            selectableEmployees={selectableEmployees}
            targetDate={targetDate}
            handlePrevMonthClick={handlePrevMonthClick}
            handleNextMonthClick={handleNextMonthClick}
          />
        </EmployeeLayoutMainContent>
      </EmployeeLayout>
    </>
  );
};
